import { ERequestStatus } from '../../types/requestStatus';
import {
  EGetRealtorRatingActionType,
  EResetRealtorRatingListActionType,
  TRealtorRatingListActions,
} from '../../actions/realtorRatingList';
import { TRealtorRatingListState } from '../../types/realtorRatingList';

export const defaultState: TRealtorRatingListState = {
  status: ERequestStatus.Initial,
  items: [],
};

export const realtorRatingListReducer = (state = defaultState, action: TRealtorRatingListActions) => {
  switch (action.type) {
    case EGetRealtorRatingActionType.Loading:
      return { ...state, status: ERequestStatus.Loading };

    case EGetRealtorRatingActionType.Succeed:
      return { ...state, ...action.payload, status: ERequestStatus.Succeed };

    case EGetRealtorRatingActionType.Failed:
      return { ...state, status: ERequestStatus.Failed };

    case EResetRealtorRatingListActionType.Reset:
      return defaultState;

    default:
      return state;
  }
};
